__turbopack_context__.v({
  "persons": "styles-module-scss-module__6Tk2wq__persons",
  "section": "styles-module-scss-module__6Tk2wq__section",
});
